module.exports = __webpack_public_path__ + "img/alarm-snooze.a149595d.svg";